<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/userStore'

const userStore = useUserStore()
const router = useRouter()

onMounted(() => {
  console.log('🚀 App mounted, triggering auth initialization')

  // CRITICAL FIX: Intercept OAuth code when it appears on root URL
  // This happens when OAuth provider redirects directly to Site URL instead of callback
  const currentPath = window.location.pathname
  const searchParams = window.location.search

  console.log('🔍 App mount - checking for OAuth code:', {
    path: currentPath,
    hasSearchParams: searchParams.length > 0,
    searchParams: searchParams
  })

  // If we're on root URL with a code parameter, redirect to auth callback
  if (currentPath === '/' && searchParams.includes('code=')) {
    console.log('⚠️ OAuth code detected on root URL! Redirecting to /auth/callback...')
    console.log('📍 Original URL:', window.location.href)

    // Preserve all query parameters when redirecting
    const redirectUrl = `/auth/callback${searchParams}`
    console.log('🚀 Redirecting to:', redirectUrl)

    // Use replace to avoid adding to browser history
    router.replace(redirectUrl)
    return // Exit early to avoid initializing auth twice
  }

  // Normal auth initialization
  if (!userStore.initialized) {
    userStore.initializeAuth()
  }
})
</script>

<template>
  <RouterView />
</template>

<style>
/* Global styles can be added here if needed */
</style>
